import { state } from "../state";

/* Class Trabaja */
export class TrabajaPage extends HTMLElement {

    connectedCallback() {
        this.render();
        state.dataJob();
    }

    render() {
        this.className = 'trabaja-page';
        this.innerHTML =
        `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">
                    <div class="body__cuerpo trabaja__header">
                        <div class="trabaja__header-text">
                            <h3 class="body__cuerpo-text-title">¡Estas son nuestras búsquedas activas!</h3>
                            <a class="formulario__cv" href="https://forms.gle/1yDoAo8U9ZGRntNX8">Carga tu CV</a>
                        </div>
                    </div>
                    <div class="body__cuerpo">
                        <div class="job__container">
                            <template class="job__template">
                                <div class="job__box">
                                    <h2 class="job__titulo">Puesto Solicitado</h2>
                                    <div class="job__etiquetas">
                                        <h2 class="job__disponibilidad">Disponibilidad</h2>
                                    </div>
                                    <p class="job__descripcion">Descripcion del puesto buscado.</p>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="body__cuerpo trabaja__footer">
                        <div class="trabaja__enviar">
                            <h3 class="enviar">¿Dónde puedo enviar mi CV?</h3>
                            <h5 class="enviar-info">Para enviar CV, hacerlo a seleccion@sanatorioprivado.com.ar e indicar el puesto de interés en el asunto del mail.</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `
    }
}

/* Define */
customElements.define("trabaja-page", TrabajaPage)
